//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.section`
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    padding: 28px 28px 18px;
    max-height: calc(100vh - 72px);
    @media (min-width: 760px) {
        min-width: ${({ minWidth = "400px" }) => minWidth};
    }
    width: 100%;
    gap: ${({ gap = "35px" }) => gap};

    @media (max-width: 900px) {
        padding: 24px 20px 16px;
        max-height: calc(100vh - 56px);
    }

    @media (max-width: 560px) {
        padding: 22px 16px 14px;
    }
`;
export const Content = styled.article`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: ${({ width = "80%" }) => width};
    max-width: 100%;
    min-width: 0;
    gap: ${({ gap = "6px" }) => gap};
    & img {
        width: 50%;
    }
    &.content-component img {
        width: 240px;
    }
    & > h3 {
        color: var(--purple-6);
        &.secondary {
            color: var(--dark-4);
        }
        font-weight: 900;
        font-size: 22px;
        text-align: center;
        margin: 12px 0;
        margin-top: 25px;
    }
    &:not(.content-component) > p { margin: 0; }
    & .paragraph {
        color: var(--light-gray-5);
        font-size: 14px;
        margin: 0;
        list-style: none;
        &.center {
            text-align: center;
            width: 100%;
        }
    }
    & .list {
        font-size: 14px;
        line-height: 20px;
        width: max-content;
        padding: 0;
        margin: 0;
    }
`;
export const Footer = styled.footer`
    display: flex;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    gap: 15px;
    flex-wrap: wrap;
    justify-content: center;
`;
